import { CatalogItemProps } from 'src/contexts/discovery'

export function excludeField(
  catalog: CatalogItemProps,
  field: keyof CatalogItemProps,
) {
  if (
    field.includes('catalog-editor') ||
    (field.includes('catalog-repository') && !catalog[field])
  ) {
    return true
  }
}
